import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

export var LogSearch =
/*#__PURE__*/
function () {
  /**
   * @param {LogProvider} provider
   */
  function LogSearch(provider) {
    _classCallCheck(this, LogSearch);

    _defineProperty(this, "name", 'logreader-search');

    this.provider = provider;
    this.initialize();
  }

  _createClass(LogSearch, [{
    key: "initialize",
    value: function initialize() {
      OC.Plugins.register('OCA.Search.Core', this);
    }
  }, {
    key: "attach",
    value: function attach(search) {
      var _this = this;

      search.setFilter('settings', _.debounce(function (query) {
        if (query.length >= 3 || query == '') {
          _this.provider.query = query;
        }
      }, 250));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return LogSearch;
}();
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(LogSearch, "LogSearch", "/srv/http/owncloud/apps/logreader/js/Search.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();